<template>
  <div class="content-wrapper">
    <StripeForm />
  </div>
</template>

<script>
import { layouts } from '../../helpers'
import StripeForm from '@/components/Universal/StripeForm'

export default {
  name: 'AddPaymentMethod',
  components: {
    StripeForm
  },
  created() {
    this.$store.dispatch('layout/setPageLayout', layouts.PAIGE_DASHBOARD)
  }
}
</script>

<style scoped lang="scss">
@import '@/global.scss';

form {
  padding-top: 5rem;
  width: 40%;
  height: 100vh;
  margin: 0 auto;

  h1 {
    padding-bottom: 2rem;
  }

  a:hover {
    color: $onyx;
  }

  .inline-inputs {
    display: flex;
    justify-content: space-between;
  }
}
</style>
